import {combineReducers} from "redux";

import {reduceResponse} from "@pg-mono/request-state";

import type {IArticleListArticle} from "../../../article/actions/fetch_article_list";
import type {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {fetchPriceReportRegionTypes} from "../actions/fetch_price_report_region";
import {fetchPricesArticleListTypes} from "../actions/fetch_prices_article_list";
import {fetchPricesAvailableDateTypes} from "../actions/fetch_prices_available_date";
import {fetchReportPriceAveragePricesTypes, fetchReportPriceYearAgoAveragePricesTypes} from "../actions/fetch_report_price_average_prices";
import {fetchReportPriceAllCitiesPrices} from "../api/fetch_all_cities_prices";
import {fetchReportPriceAllCitiesPricesSOld} from "../api/fetch_all_cities_prices_old";
import type {IPriceReportAveragePrices} from "../types/IPriceReportAveragePrices";
import type {IPricesAvailableDate} from "../types/IPricesAvailableDate";

export interface IPriceReportStore {
    pricesAvailableDate: IPricesAvailableDate | null;
    region: IRegionReportPrice | null;
    prices: IPriceReportAveragePrices[] | null;
    yearAgoPrices: IPriceReportAveragePrices | null;
    allCitiesData: IPriceReportAveragePrices[] | null;
    allCitiesDataOld: IPriceReportAveragePrices[] | null;
    articles: IArticleListArticle[];
}

export const priceReportReducer = combineReducers({
    pricesAvailableDate: reduceResponse<IPricesAvailableDate>(fetchPricesAvailableDateTypes, null),
    region: reduceResponse<IRegionReportPrice>(fetchPriceReportRegionTypes),
    prices: reduceResponse<IPriceReportAveragePrices[]>(fetchReportPriceAveragePricesTypes),
    yearAgoPrices: reduceResponse<IPriceReportAveragePrices>(fetchReportPriceYearAgoAveragePricesTypes),
    allCitiesData: reduceResponse<IPriceReportAveragePrices[]>(fetchReportPriceAllCitiesPrices),
    allCitiesDataOld: reduceResponse<IPriceReportAveragePrices[]>(fetchReportPriceAllCitiesPricesSOld),
    articles: reduceResponse<IArticleListArticle[]>(fetchPricesArticleListTypes, [])
});
import {combineReducers} from "redux";

import {reduceResponse} from "@pg-mono/request-state";

import type {IArticleListArticle} from "../../../article/actions/fetch_article_list";
import type {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {fetchPriceReportRegionTypes} from "../actions/fetch_price_report_region";
import {fetchPricesArticleListTypes} from "../actions/fetch_prices_article_list";
import {fetchPricesAvailableDateTypes} from "../actions/fetch_prices_available_date";
import {fetchReportPriceAveragePricesTypes, fetchReportPriceYearAgoAveragePricesTypes} from "../actions/fetch_report_price_average_prices";
import {fetchReportPriceAllCitiesPrices} from "../api/fetch_all_cities_prices";
import {fetchReportPriceAllCitiesPricesSOld} from "../api/fetch_all_cities_prices_old";
import type {IPriceReportAveragePrices} from "../types/IPriceReportAveragePrices";
import type {IPricesAvailableDate} from "../types/IPricesAvailableDate";

export interface IPriceReportStore {
    pricesAvailableDate: IPricesAvailableDate | null;
    region: IRegionReportPrice | null;
    prices: IPriceReportAveragePrices[] | null;
    yearAgoPrices: IPriceReportAveragePrices | null;
    allCitiesData: IPriceReportAveragePrices[] | null;
    allCitiesDataOld: IPriceReportAveragePrices[] | null;
    articles: IArticleListArticle[];
}

export const priceReportReducer = combineReducers({
    pricesAvailableDate: reduceResponse<IPricesAvailableDate>(fetchPricesAvailableDateTypes, null),
    region: reduceResponse<IRegionReportPrice>(fetchPriceReportRegionTypes),
    prices: reduceResponse<IPriceReportAveragePrices[]>(fetchReportPriceAveragePricesTypes),
    yearAgoPrices: reduceResponse<IPriceReportAveragePrices>(fetchReportPriceYearAgoAveragePricesTypes),
    allCitiesData: reduceResponse<IPriceReportAveragePrices[]>(fetchReportPriceAllCitiesPrices),
    allCitiesDataOld: reduceResponse<IPriceReportAveragePrices[]>(fetchReportPriceAllCitiesPricesSOld),
    articles: reduceResponse<IArticleListArticle[]>(fetchPricesArticleListTypes, [])
});
